import { ParamField } from '../../../core/query/entities/url-query-params.entity';

export enum SearchMode {
    Global = ParamField.Global,
    Semantic = ParamField.Semantic,
    FullText = ParamField.FullText
}
